import Icon from '@react/react-spectrum/Icon';
import React from 'react';

const AdobeExCIcon = (props) => {
  return (
    <Icon {...props}>
      <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 234">
        <rect width="240" height="234" rx="42.5" style={{fill: '#fa0f00'}}/>
        <path id="_256" data-name="256" style={{fill: '#fff'}} d="M186.617,175.95037H158.11058a6.24325,6.24325,0,0,1-5.84652-3.76911L121.31715,99.82211a1.36371,1.36371,0,0,0-2.61145-.034l-19.286,45.94252A1.63479,1.63479,0,0,0,100.92626,148h21.1992a3.26957,3.26957,0,0,1,3.01052,1.99409l9.2814,20.65452a3.81249,3.81249,0,0,1-3.5078,5.30176H53.734a3.51828,3.51828,0,0,1-3.2129-4.90437L99.61068,54.14376A6.639,6.639,0,0,1,105.843,50h28.31354a6.6281,6.6281,0,0,1,6.23289,4.14376L189.81885,171.046A3.51717,3.51717,0,0,1,186.617,175.95037Z"/>
      </svg>
    </Icon>
  );
};

export default AdobeExCIcon;



// WEBPACK FOOTER //
// ./src/components/ExpLogin/constants/AdobeExCIcon.js